var _rect, _path, _path2, _rect2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFlipkartVipIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-1 0 0 1 52 4)",
    fill: "#AE285D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9931 18.5527C26.8708 20.4807 25.7388 22.4031 24.6286 24.3384C26.423 27.5037 28.1915 30.6843 30.0466 33.8148C30.7584 35.0165 31.4507 36.2295 32.1544 37.4352C34.4363 37.449 36.7181 37.4482 39 37.4449C38.9304 37.2886 38.8615 37.1315 38.7773 36.9826C35.1845 30.8382 31.5779 24.7019 27.9931 18.5527Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9922 30.3068C25.7022 30.306 23.4123 30.2898 21.1223 30.3279C19.7587 32.7053 18.3514 35.0568 16.9999 37.4407C19.2898 37.452 21.579 37.4431 23.869 37.4415C25.2318 35.056 26.6553 32.7069 27.9922 30.3068Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#130524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4599 17.4995H27.6674L29.5096 20.2144L22.7432 31.4777L16 20.3153L17.4599 17.4995Z",
    fill: "url(#paint0_linear_7843_19054)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.043 17.7678L24.5655 33.6419C24.5075 33.7429 24.496 33.8775 24.5655 33.9897L27.0333 38.32C27.1724 38.5556 27.52 38.5668 27.659 38.32L39.952 18.0707C40.0911 17.8351 39.9173 17.5435 39.6392 17.5435L34.3443 17.5995C34.2168 17.5995 34.101 17.6669 34.0315 17.779L34.043 17.7678Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7843_19054",
    x1: 17.7611,
    y1: 17.0956,
    x2: 26.8807,
    y2: 26.7572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D08A0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ECB856"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlipkartVipIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flipkartVipIcon.f9403343.svg";
export { ForwardRef as ReactComponent };